import { useMemo } from 'react';
import { useRouteLocations } from '@lp/features/RoutePlanner/hooks/useRouteLocations';
import { BaseSuggestedRouteProps } from '@lp/features/MultiSuggest';
import { RouteProvider } from '@lp/core/contexts/RouteContext';
import { AircraftUtilizationProvider } from '@lp/features/RoutePlanner/contexts/AircraftUtilizationContext';
import { LegLocationTypeEnum, RouteTypeEnum } from '@/api/apis/route';
import { useBaseCaseDetails } from '@/hooks/useBaseCaseDetails';
import { useMultiSuggestionItemByChainQuery } from '@/queries/multi-suggest';
import { SegmentsList } from './SegmentsList';
import { DataCacheType } from '@/queries/consts';

export const SuggestedRouteList = ({ taskId, chainNumber }: BaseSuggestedRouteProps) => {
  const { caseId } = useBaseCaseDetails();
  const { list } = useRouteLocations(DataCacheType.Snapshot);
  const { data } = useMultiSuggestionItemByChainQuery(taskId, chainNumber, caseId);

  const locations = useMemo(() => {
    const mainLocations = list.filter((l) =>
      [LegLocationTypeEnum.hospital, LegLocationTypeEnum.txcenter].includes(l.locationType),
    );

    return [...(data?.locations || []), ...mainLocations];
  }, [data?.locations, list]);

  if (!data) return null;

  return (
    <RouteProvider locations={locations} resources={data.resources}>
      <AircraftUtilizationProvider>
        <div className="flex flex-col gap-4 flex-1/2 overflow-y-auto bg-base-90 p-4 rounded-r-lg">
          <span className="text-l-cps text-base-30">SUGGESTED</span>
          <SegmentsList
            routeType={RouteTypeEnum.Main}
            segments={data.segments}
            legs={data.legs}
            accommodationLegs={data.accommodationLegs}
          />
        </div>
      </AircraftUtilizationProvider>
    </RouteProvider>
  );
};
